export const is360 = () => {
  return Boolean(window.localStorage.getItem('qhclickid'))
}
